/**
 * Utility functions for plan-related operations
 */

/**
 * Check if a user has a Pro plan
 * @param plan - The user's current plan
 * @param licenseType - The user's license type (optional)
 * @returns true if the user has a Pro plan
 */
export const isProPlan = (plan?: string, licenseType?: string): boolean => {
  if (!plan) return false;
  
  // Check if plan starts with 'pro-' or is exactly 'pro'
  if (plan.startsWith('pro-') || plan === 'pro') {
    return true;
  }
  
  // Check for density-pro plans
  if (plan.includes('density-pro')) {
    return true;
  }
  
  // Check license type for additional pro indicators
  if (licenseType && (licenseType === 'pro' || licenseType.includes('pro'))) {
    return true;
  }
  
  return false;
};

/**
 * Check if a user has a Premium plan (includes old Medium plans)
 * @param plan - The user's current plan
 * @returns true if the user has a Premium or Medium plan
 */
export const isPremiumPlan = (plan?: string): boolean => {
  if (!plan) return false;
  
  // Premium plans include both 'premium' and old 'medium' plans
  return plan === 'premium' || plan === 'medium';
};

/**
 * Check if a user has a Free plan
 * @param plan - The user's current plan
 * @returns true if the user has a Free plan
 */
export const isFreePlan = (plan?: string): boolean => {
  return !plan || plan === 'free';
};

/**
 * Check if a user has an RTO (Rent-to-Own) plan
 * @param plan - The user's current plan
 * @returns true if the user has an RTO plan
 */
export const isRTOPlan = (plan?: string): boolean => {
  if (!plan) return false;
  return plan === 'rto' || plan.includes('rent-to-own');
};